import axios from 'axios';
import { header } from '../components/header.encry';
import { fetchPlateformsByStore } from '../components/PlateformService';
import { buildGlovoLiveSyncTargets } from '../utils/glovoLiveSyncTargets';

export async function syncGlovoStoreLive(store, platformType = 'glovo_sisters', { allowMissing = false } = {}) {
  if (platformType !== 'glovo_sisters') throw new Error('Ce service est réservé à Glovo Sisters.');
  const response = await fetchPlateformsByStore(store.storeId);
  const platforms = Array.isArray(response) ? response : response?.response || response?.data || [];
  const targets = buildGlovoLiveSyncTargets(platforms, store, platformType);
  if (!targets.length && !allowMissing) throw new Error('Aucune plateforme Glovo Sisters Portal configurée pour ce magasin.');
  const result = { processed: 0, inserted: 0, errors: [] };
  for (const target of targets) {
    if (target.error) {
      result.errors.push({ message: target.error, plateformId: target.plateformId });
      continue;
    }
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_PEGASUS_API_URL || 'https://api.pegasus.le-celadon.ma'}/glovo/live-order/sync`, target, header()
      );
      result.processed += Number(data?.processed || 0);
      result.inserted += Number(data?.inserted || 0);
      if (data?.success !== true) result.errors.push(...(data?.errors?.length ? data.errors : [{ message: 'Synchronisation non confirmée.' }]));
    } catch (error) {
      result.errors.push({ message: error.response?.data?.error || error.message, plateformId: target.plateformId });
    }
  }
  return { ...result, success: result.errors.length === 0 };
}
